// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__wASwP","disabled":"Navigation_disabled__3ULMh","hasSubEntries":"Navigation_hasSubEntries__25gfX"};